if($(".ace-switch").length){
  init_ace_switch();
}

window.init_ace_switch = init_ace_switch;

function init_ace_switch(){
    $(".ace-switch").each(function(){
        if($(this).siblings('.lbl').length != 0){ return true; } //next
        var $input = $(this);
        $input.addClass("hidden").css({"width": 0, "margin": 0, "padding": 0});
        // Reflect actual checked state with the CSS class on load
        if($input.is(':checked')){
            $input.addClass("checked");
        }
        var $lbl = $("<span class='lbl'></span>");
        $input.closest("label").append($lbl);
        $(".checkbox").css({"padding": 0});
        // Bind handler to this specific lbl/input pair to avoid multiple firings
        $lbl.on("click", function(event){
            event.stopPropagation();
            var $checkbox = $(this).siblings("input.ace-switch");
            var checked = $checkbox.hasClass("checked");
            if(checked){
                $checkbox.removeClass("checked").prop("checked", false);
            } else{
                $checkbox.addClass("checked").prop("checked", true);
            }
        });
    });
}
